import {
  Checkbox,
  FormControlLabel,
  FormControlLabelProps,
  FormHelperText,
} from "@mui/material";
import { Field, FieldProps } from "formik";
import * as React from "react";

interface FormikCheckFieldProps extends Omit<FormControlLabelProps, "control"> {
  name: string;
}

export const FormikCheckField: React.FC<FormikCheckFieldProps> = (props) => (
  <Field name={props.name}>
    {({ field, meta }: FieldProps<boolean>) => (
      <>
        <FormControlLabel
          sx={{ mt: 1 }}
          {...props}
          control={<Checkbox checked={meta.value} color="primary" {...field} />}
        />
        {Boolean(meta.touched && meta.error) && (
          <FormHelperText error>{meta.error}</FormHelperText>
        )}
      </>
    )}
  </Field>
);
